import AmpersandState from 'ampersand-state';

import CustomFieldParamsData from './gd-custom-field-params-data';
import CustomFieldsV1 from "core/gd/const/fields/custom-fields-v1";

const GDCustomField = AmpersandState.extend({
    idAttribute: 'id',
    props: {
        id: 'string',
        companyId: 'string',

        name: 'string',
        type: 'number',

        access: 'number',

        isDeleted: {
            type: 'boolean',
            default: false
        },

        sortPosition: 'number',
        isInherited: {
            type: 'boolean',
            default: false
        },

        params: 'object'
    },

    derived: {
        defaultValue: {
            deps: ['type'],
            fn: function() {
                let res = null;
                switch(this.type) {
                    case gd.const.customFields.type.STRING:         res = "";       break;
                    case gd.const.customFields.type.BOOLEAN:        res = false;    break;
                    case gd.const.customFields.type.NUMBER:         res = null;     break;
                    case gd.const.customFields.type.CURRENCY:       res = null;     break;
                    case gd.const.customFields.type.PERCENTAGE:     res = null;     break;
                    case gd.const.customFields.type.DATE:           res = null;     break;
                    case gd.const.customFields.type.LIST:           res = null;     break;
                    case gd.const.customFields.type.LIST_MULTI:     res = [];       break;
                    case gd.const.customFields.type.RATING:         res = null;     break;
                    case gd.const.customFields.type.EMAIL:          res = null;     break;
                    case gd.const.customFields.type.PHONE:          res = null;     break;
                    case gd.const.customFields.type.URL:            res = null;     break;
                    case gd.const.customFields.type.USER:           res = null;     break;
                    case gd.const.customFields.type.USERS:          res = null;     break;
                    case gd.const.customFields.type.RAG:            res = null;     break;
                    case gd.const.customFields.type.FORMULA:        res = "";       break;
                }

                return res;
            }
        },

        valueType: {
            deps: ['type'],
            fn: function() {
                let res = null;
                switch(this.type){
                    case gd.const.customFields.type.STRING:         res = gd.const.fields.valueType.STRING;       break;
                    case gd.const.customFields.type.BOOLEAN:        res = gd.const.fields.valueType.BOOLEAN;      break;
                    case gd.const.customFields.type.NUMBER:         res = gd.const.fields.valueType.FLOAT;        break;
                    case gd.const.customFields.type.CURRENCY:       res = gd.const.fields.valueType.FLOAT;        break;
                    case gd.const.customFields.type.PERCENTAGE:     res = gd.const.fields.valueType.FLOAT;        break;
                    case gd.const.customFields.type.DATE:           res = gd.const.fields.valueType.STRING;       break;
                    case gd.const.customFields.type.LIST:           res = gd.const.fields.valueType.FLOAT;        break;
                    case gd.const.customFields.type.LIST_MULTI:     res = gd.const.fields.valueType.JSON;         break;
                    case gd.const.customFields.type.RATING:         res = gd.const.fields.valueType.FLOAT;        break;
                    case gd.const.customFields.type.EMAIL:          res = gd.const.fields.valueType.STRING;       break;
                    case gd.const.customFields.type.PHONE:          res = gd.const.fields.valueType.STRING;       break;
                    case gd.const.customFields.type.URL:            res = gd.const.fields.valueType.STRING;       break;
                    case gd.const.customFields.type.USER:           res = gd.const.fields.valueType.STRING;       break;
                    case gd.const.customFields.type.USERS:          res = gd.const.fields.valueType.JSON;         break;
                    case gd.const.customFields.type.TEXT:           res = gd.const.fields.valueType.STRING;       break;
                    case gd.const.customFields.type.RAG:            res = gd.const.fields.valueType.FLOAT;        break;
                    case gd.const.customFields.type.FORMULA:        res = gd.const.fields.valueType.STRING;       break;
                    case gd.const.customFields.type.COLOR:          res = gd.const.fields.valueType.FLOAT;        break;

                    case CustomFieldsV1.type.REACTION:
                    case CustomFieldsV1.type.VOTING:
                    case CustomFieldsV1.type.ADDRESS:
                    case CustomFieldsV1.type.ATTACHMENT:
                        return gd.const.fields.valueType.JSON;

                    case CustomFieldsV1.type.TIME_OF_DAY:  return gd.const.fields.valueType.JSON; // Tut Moment?!
                    case CustomFieldsV1.type.DATE_AND_TIME:  return gd.const.fields.valueType.JSON; // Tut Moment?!
                    case CustomFieldsV1.type.TOGGLE:  return gd.const.fields.valueType.BOOLEAN;

                    default:
                        console.error("#Error #kdji213 no custom field type found")
                }

                return res;
            }
        },

        typeName: {
            deps: ['type'],
            fn: function() {
                let res = null;
                switch(this.type){
                    case gd.const.customFields.type.STRING:         res = "string";         break;
                    case gd.const.customFields.type.BOOLEAN:        res = "boolean";        break;
                    case gd.const.customFields.type.NUMBER:         res = "number";         break;
                    case gd.const.customFields.type.CURRENCY:       res = "currency";       break;
                    case gd.const.customFields.type.PERCENTAGE:     res = "percentage";     break;
                    case gd.const.customFields.type.DATE:           res = "date";           break;
                    case gd.const.customFields.type.LIST:           res = "list";           break;
                    case gd.const.customFields.type.LIST_MULTI:     res = "list";           break;
                    case gd.const.customFields.type.RATING:         res = "rating";         break;
                    case gd.const.customFields.type.EMAIL:          res = "email";          break;
                    case gd.const.customFields.type.PHONE:          res = "phone";          break;
                    case gd.const.customFields.type.URL:            res = "url";            break;
                    case gd.const.customFields.type.USER:           res = "user";           break;
                    case gd.const.customFields.type.USERS:          res = "users";          break;
                    case gd.const.customFields.type.TEXT:           res = "text";           break;
                    case gd.const.customFields.type.RAG:            res = "number";         break;
                    case gd.const.customFields.type.COLOR:          res = "number";         break;
                }

                return res;
            }
        },

        icon: {
            deps: ['type'],
            fn: function() {
                const cf = gd.const.customFields[this.type];
                return cf ? cf.icon : '';
            }
        },

        // not in use experimental shit
        listColumnWidth: {
            deps: ['type','name'],
            fn: function() {

                let defaultWidth = 100;

                switch(this.type) {

                    case gd.const.customFields.type.CURRENCY:
                    case gd.const.customFields.type.DATE:
                    case gd.const.customFields.type.LIST:
                        defaultWidth = 100;
                        break;

                    case gd.const.customFields.type.EMAIL:
                        defaultWidth = 180;
                        break;

                    case gd.const.customFields.type.LIST_MULTI:
                    case gd.const.customFields.type.TEXT:
                        defaultWidth = 200;
                        break;

                    case gd.const.customFields.type.STRING:
                    case gd.const.customFields.type.PHONE:
                    case gd.const.customFields.type.URL:
                    case gd.const.customFields.type.USER:
                    case gd.const.customFields.type.USERS:
                        defaultWidth = 160;
                        break;
                    case gd.const.customFields.type.BOOLEAN:
                    case gd.const.customFields.type.NUMBER:
                    case gd.const.customFields.type.PERCENTAGE:
                    case gd.const.customFields.type.RAG:
                    case gd.const.customFields.type.COLOR:
                        defaultWidth = 90;
                        break;

                    case gd.const.customFields.type.RATING:
                        defaultWidth = 136;
                        break;

                    case CustomFieldsV1.type.ADDRESS:
                        defaultWidth = 200;
                        break

                    case CustomFieldsV1.type.ATTACHMENT:
                        defaultWidth = 200;
                        break;
                }
                const titleWidth = this.getTitleWidth();

                if (titleWidth + 30 > defaultWidth) {
                    defaultWidth = titleWidth + 30;
                }

                return defaultWidth;
            }
        }
    },

    getTitleWidth() {

        const symbols = this.name.length;

        if (symbols<=6) return 50;
        if (symbols<=10) return 75;
        if (symbols<=15) return 110;
        return 120;
    },

    clone() {
        return new GDCustomField(this.toJSON());
    },

    setInherited(value) {
        this.isInherited = value;
    },

    // it is used !!!
    updatePayload(value) {
        return {
            value       : value,
            type        : this.valueType
        }
    },

    parse(obj) {
        obj.params = CustomFieldParamsData.normalize(obj.params);

        return obj;
    }
});

module.exports = GDCustomField;
